import React from 'react';
import { Show, SimpleShowLayout, TextField, ReferenceField } from 'react-admin';

const PrestacionGrupoReglaShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <ReferenceField
        source="idGrupoRegla"
        reference="grupo-regla"
        label="Grupo Regla"
      >
        <TextField source="descripcion" />
      </ReferenceField>
      <ReferenceField
        source="idPrestacion"
        reference="prestaciones"
        label="Prestacion"
      >
        <TextField source="descripcion" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
);

export default PrestacionGrupoReglaShow;
